import styled from 'styled-components';

const StyledBoxBody = styled.div`
  padding: 5px 10px;
  background-color: white;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export default StyledBoxBody;
